import React, { useEffect } from 'react';
import { Select } from 'components';
import Input from 'components/Inputs/input/input';
import { OptionWrapper } from 'components/select/select';
import { FreeText } from './types';
import { RowComponentBaseProps } from '../multi-condition/multi-condition';

import './single-free-text-row.scss';

export interface FreeTextRowProps extends RowComponentBaseProps<FreeText> {
	options: (OptionWrapper & { id: FreeText['operator'] })[];
	parentContainerClass?: string;
}

const INPUT_WIDTH = 200;

const SingleFreeTextRow = ({
	singleCondition,
	onChange,
	setIsValid,
	options,
	parentContainerClass,
	disabled = false
}: FreeTextRowProps) => {
	const OPERATOR = 'operator';
	const VALUE = 'value';

	const handleChange = (key, value) => {
		onChange({
			...singleCondition,
			[key]: value
		});
	};

	useEffect(() => {
		setIsValid(!!(singleCondition.operator && singleCondition.value !== undefined));
	}, [singleCondition]);

	const otherProps = {};
	if (parentContainerClass) {
		otherProps['getPopupContainer'] = () => document.querySelector(`.${parentContainerClass}`);
	}

	return (
		<>
			<Select
				disabled={disabled}
				className="free-text-select-operator"
				data-test-id="free-text-select-operator"
				options={options}
				onChange={value => handleChange(OPERATOR, value)}
				value={singleCondition.operator}
				allowClear={true}
				style={{ width: INPUT_WIDTH }}
				{...otherProps}
			/>
			{singleCondition.operator && (
				<Input
					disabled={disabled}
					data-test-id="free-text-value"
					placeholder=""
					defaultValue={singleCondition.value}
					onChange={event => handleChange(VALUE, event.target.value)}
					style={{ width: INPUT_WIDTH }}
				/>
			)}
		</>
	);
};

export default SingleFreeTextRow;
